module.exports = __webpack_public_path__ + "static/media/testimoni3.a1987fe8.png";